import { db } from '@/firebase.js'
export default({
  state:{
    textList: []
  },
  mutations:{
    bindTexts(state){
      db.collection('teksty').get().then(querySnapshot=>{
        querySnapshot.forEach(doc=>{
          let content = doc.data().content;
          let title = doc.data().title;
          state.textList.push({
            content,
            title
          })
        })
      })
    },
  },
  actions:{
  },
  getters:{}
})
